/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Typography from "../../../components/common/new/Typography/Typography";
import Member from "../../../services/api/member";
import DashboardForMobile from "./Dashboard/DashboardForMobile";
import MemberDetailCardsForMobile from "./MemberDetailCards/MemberDetailsCardsForMobile";

import useUserConfig from "../../../hooks/useUserConfig";
import {
  getFormattedAppointments,
  getFormattedData,
  getFormattedMembers,
  getFormattedGohonzon,
  getFormattedPreviousAppointments,
  getFormattedSubscription,
  getFormattedAllPreviousAppointments,
  getFormattedExam,
  getFormattedAward,
  getFormattedSpecial,
  getFormattedHdc,
} from "./utlis";
import Family from "../../../services/api/Family";
import Loader from "../../../components/common/Loader/Loader";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    margin: "0 -2.65%",
    backgroundColor: "#F7F7F9",
  },
  leftContainer: {
    flex: 1,
    minWidth: 150,
  },
  rightContainer: {
    display: "flex",
    flex: 4,
  },
  tabsStyle: {
    textTransform: "uppercase",
    cursor: "pointer",
    fontSize: "10px",
    font: "normal 600 12px",
    paddingBottom: "8px",
    paddingTop: "8px",
  },
  memberIdStyle: {
    color: "#183053",
    fontWeight: "600",
  },
};

function MembersDetailForMobile() {
  const [memberInfo, setMemberInfo] = useState({});
  const [attendanceInfo, setAttendanceInfo] = useState({});
  const [appointmentInfo, setAppointmentInfo] = useState([]);
  const [familyMemberInfo, setFamilyMemebrInfo] = useState([]);
  const [gohonzonMemberInfo, setGohonzonMemberInfo] = useState([]);
  const [previousAppointmentInfo, setPreviousAppointmentInfo] = useState([]);
  const [inProgressAppointmentInfo, setInprogressAppointmentInfo] = useState(
    []
  );
  const [hdcInfo, setHdcInfo] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [subscriptionMemberInfo, setSubscriptionMemberInfo] = useState([]);
  const [examMemberInfo, setExamMemberInfo] = useState([]);
  const [awardMemberInfo, setAwardMemberInfo] = useState([]);
  const [specialMemberInfo, setSpecialMemberInfo] = useState([]);
  const { id } = useParams();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const hasPermission = useUserConfig();
  const memberViewId = memberInfo.memberId;

  const handleRemoveItem = () => {
    const updatedItems = familyMemberInfo.filter(
      (item) => item.memberId !== memberViewId
    );

    return updatedItems;
  };

  const updatedFamilyMemberInfo = handleRemoveItem();

  const fetchMemberData = async (memberId) => {
    console.log("LOGGER_HISTORY");
    setIsLoading(true);

    try {
      const memberInfoData = await Member.memberView(memberId);
      setMemberInfo(memberInfoData.data);
      setGohonzonMemberInfo(getFormattedGohonzon(memberInfoData.data));
      setSpecialMemberInfo(
        getFormattedSpecial(memberInfoData.data.inductionSpecialGroups)
      );
      setHdcInfo(getFormattedHdc(memberInfoData.data));
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Attendance API
    try {
      console.log("LOGGER_HISTORY_ENTER");
      const attendanceData = await Member.getAttendanceByMemberId(memberId);
      setAttendanceInfo(getFormattedData(attendanceData.data.content));
      console.log("LOGGER_HISTORY", attendanceData);
    } catch (error) {
      console.log("LOGGER_HISTORY_ERROR", error);
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Appointment API
    try {
      const appointmentData = await Member.getCurrentAppointmentsByMemberId(
        memberId
      );
      setAppointmentInfo(
        getFormattedAppointments(appointmentData.data.content)
      );
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Previous API
    try {
      const previousAppointmentData = await Member.getAppointmentsByMemberId(
        memberId
      );
      setPreviousAppointmentInfo(
        getFormattedPreviousAppointments(previousAppointmentData.data.content)
      );
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling InprogressAppointment API
    try {
      const inprogressAppointmentData = await Member.getMemberDetailsById(
        memberId
      );
      setInprogressAppointmentInfo(
        getFormattedAllPreviousAppointments(
          inprogressAppointmentData.data.content
        )
      );
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Subscription API
    try {
      const subscriptionData = await Member.getSubscriptionByMemberId(memberId);
      setSubscriptionMemberInfo(
        getFormattedSubscription(subscriptionData.data)
      );
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Exam API
    try {
      const examData = await Member.getExamByMemberId(memberId);
      setExamMemberInfo(getFormattedExam(examData.data));
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Awards API
    try {
      const awardData = await Member.getAwardByMemberId(memberId);
      setAwardMemberInfo(getFormattedAward(awardData.data));
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Family API
    try {
      const familyData = await Family.getFamilyDetailsByMemberId(memberId);
      setFamilyMemebrInfo(getFormattedMembers(familyData?.data?.familyMembers));
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onRefresh = () => {
    fetchMemberData(memberInfo.memberId);
  };

  useEffect(() => {
    if (id) {
      fetchMemberData(id);
    }
  }, [id]);
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        mb={4}
      >
        <Typography variant="small" weight={500} color="#183053">
          Member ID: {memberInfo.memberId}
        </Typography>
        <Typography variant="small" weight={500} color="#183053">
          {/* {Object?.values(userOSNames)?.join("/")} */}
          {[
            memberInfo?.areaName,
            memberInfo?.clusterName,
            memberInfo?.zoneName,
            memberInfo?.regionName,
            memberInfo?.chapterName,
            memberInfo?.districtName,
            memberInfo?.blockName,
          ]
            .filter(Boolean)
            .join("/ ")}
        </Typography>
      </Box>
      <Box
        style={{
          ...styles.container,
          ...(isMobile && { overflowX: "hidden" }),
        }}
      >
        <Box style={styles.leftContainer}>
          <MemberDetailCardsForMobile
            memberInfo={memberInfo}
            hasPermission={hasPermission}
            onRefresh={onRefresh}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        </Box>
        <Box style={styles.rightContainer}>
          <DashboardForMobile
            memberId={memberInfo.memberId}
            attendanceInfo={attendanceInfo}
            familyMemberInfo={updatedFamilyMemberInfo}
            appointmentInfo={appointmentInfo}
            memberInfo={memberInfo}
            gohonzonMemberInfo={gohonzonMemberInfo}
            previousAppointmentInfo={previousAppointmentInfo}
            inProgressAppointmentInfo={inProgressAppointmentInfo}
            subscriptionMemberInfo={subscriptionMemberInfo}
            examMemberInfo={examMemberInfo}
            awardMemberInfo={awardMemberInfo}
            specialMemberInfo={specialMemberInfo}
            hdcInfo={hdcInfo}
            onRefresh={onRefresh}
          />
        </Box>
      </Box>
      {isLoading && <Loader />}
    </>
  );
}

export default MembersDetailForMobile;
